module.exports = __webpack_public_path__ + "static/fonts/Mont-Black.cd8ca85.ttf";